import { ChoiceOption, ChoiceValue } from 'ui/types'

export const findSelectedOptionIndex = (options: ChoiceOption[], value: ChoiceValue): number => {
  const index = options.findIndex((option) => option.value?.toString() === value?.toString())

  return index < 0 ? 0 : index + 1
}
